import PropTypes from "prop-types";
import { InputSwitch } from "primereact/inputswitch";
import Label from "./Label";

const SwitchInput = ({
  input,
  label,
  required = false,
  readOnly = false,
  disabled = false,
  meta: { touched, error },
}) => {
  return (
    <div
      className={`edexlms-field switch-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}

      {(!readOnly && (
        <div className="edexlms-switch-input">
          <InputSwitch
            id={input.name}
            checked={input.checked}
            onChange={() => input.onChange(!input.checked)}
            disabled={disabled}
          />
        </div>
      )) || <div>{input.checked ? "Yes" : "No"}</div>}
    </div>
  );
};

SwitchInput.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SwitchInput;
